import React from "react";
import {BrowserRouter as Router, Route, Routes} from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import FormManagement from "./pages/FormManagement";
import Sidebar from "./components/Sidebar";
import DashboardHeader from "./components/DashboardHeader";
import CreateFormPage from "./pages/CreateForm";
import TourManagement from "./pages/TourManagement";
import EventManagement from "./pages/EventManagement";
import UniversityManagement from "./pages/UniversityManagement";
import LoginPage from "./pages/LoginPage";
import PasswordUpdateForm from "./components/PasswordUpdateForm";
import LoginLayout from "./layouts/LoginLayout";
import PrivateRoute from "./PrivateRoute";
import RoleBasedRoute from "./RoleBasedRoute";
import PasswordResetForm from "./components/PasswordResetForm";
import NotFoundPage from "./pages/NotFoundPage";
import SubmissionsPage from "./pages/SubmissionsPage";
import UserManagement from "./pages/UserManagement";
import EmailTemplateManagement from "./pages/EmailTemplateManagement";
import Analytics from "./pages/Analytics";
import IntegrationsPage from "./pages/IntegrationsPage";
import IntegrationsManagement from "./pages/IntegrationsManagement";
import ReportsManagement from "./pages/ReportsManagement";
import MultiTourManagement from "./pages/MultiTourManagement";
import MultiFormManagement from "./pages/MultiFormManagement";
import MultiEventManagement from "./pages/MultiEventManagement";
import ExcelImporter from "./pages/Excelmporter";

import UniAdminUsers from "./pages/UniAdminUsers";
import MultiUserDashboard from "./pages/MultiUserDashboard";
import TourTemplateManagement from "./pages/TourTemplateManagement";
import EventTemplateManagement from "./pages/EventTemplateManagement";
import FormTemplateManagement from "./pages/FormTemplateManagement";
import CreateFormTemplate from "./pages/CreateFormTemplate";
import EmailTemplateTemplateManagement from "./pages/EmailTemplateTemplateManagement";
import MultiUserEvents from "./pages/MultiUserEvents";
import MultiUserForms from "./pages/MultiUserForms";
import MultiUserUsers from "./pages/MultiUserUsers";
import MultiUserTemplates from "./pages/MultiUserTemplates";
import IntegrationTemplateManagement from "./pages/IntegrationTemplateManagement";
import UnifiedIntegrationManagement from "./pages/UnifiedIntegrationManagement";
import CRMSourceIntegrationManagement from "./pages/CRMSourceIntegrationManagement";

import { isUser } from "./utils/roleUtils";



const App = () => {
    return (
        <Router>
            <Routes>
                {/* Public Routes */}
                <Route
                    path="/setup-password/:token?"
                    element={
                        <LoginLayout>
                            <PasswordUpdateForm/>
                        </LoginLayout>
                    }
                />
                <Route
                    path="/reset-password/:token?"
                    element={
                        <LoginLayout>
                            <PasswordResetForm/>
                        </LoginLayout>
                    }
                />
                <Route
                    path="/login"
                    element={
                        <LoginLayout>
                            <LoginPage/>
                        </LoginLayout>
                    }
                />
                <Route
                    path="/"
                    element={
                        <LoginLayout>
                            <LoginPage/>
                        </LoginLayout>
                    }
                />
                {/* Private Routes */}
                <Route
                    path="/dashboard"
                    element={
                        <PrivateRoute>
                            <Dashboard/>
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/forms"
                    element={
                        <PrivateRoute>
                            <FormManagement/>
                        </PrivateRoute>
                    }
                />
                 <Route
                    path="/multi-forms"
                    element={
                        <RoleBasedRoute allowedRoles={["multi_user"]}>
                            <MultiFormManagement/>
                        </RoleBasedRoute>
                    }
                />
                 <Route
                    path="/multi-tours"
                    element={
                        <RoleBasedRoute allowedRoles={["multi_user"]}>
                            <TourTemplateManagement/>
                        </RoleBasedRoute>
                    }
                />
                <Route
                    path="/multi-events/:tourId/:tourName"
                    element={
                        <RoleBasedRoute allowedRoles={["multi_user"]}>
                            <MultiEventManagement/>
                        </RoleBasedRoute>
                    }
                />
                <Route
                    path="/new-form"
                    element={
                        <PrivateRoute>
                            <CreateFormPage/>
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/tours"
                    element={
                        <PrivateRoute>
                            <TourManagement/>
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/events/:tourId/:tourName"
                    element={
                        <PrivateRoute>
                            <EventManagement/>
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/event/import/:eventId"
                    element={
                        <PrivateRoute>
                            <ExcelImporter/>
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/universities"
                    element={
                        <RoleBasedRoute allowedRoles={["super_admin"]}>
                            <UniversityManagement/>
                        </RoleBasedRoute>
                    }
                />
                <Route
                    path="/analytics"
                    element={
                        <PrivateRoute>
                            <Analytics/>
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/integrations"
                    element={
                        <RoleBasedRoute allowedRoles={["super_admin", "uni_admin", "multi_user"]}>
                            <IntegrationsPage/>
                        </RoleBasedRoute>
                    }
                />
                <Route
                    path="/manage-integrations"
                    element={
                        <RoleBasedRoute allowedRoles={["super_admin", "uni_admin", "multi_user"]}>
                            <IntegrationsManagement/>
                        </RoleBasedRoute>
                    }
                />
                <Route
                    path="/integration-templates"
                    element={
                        <RoleBasedRoute allowedRoles={["super_admin"]}>
                            <IntegrationTemplateManagement/>
                        </RoleBasedRoute>
                    }
                />
                <Route
                    path="/university-integrations"
                    element={
                        <RoleBasedRoute allowedRoles={["super_admin", "uni_admin", "multi_user"]}>
                            <UnifiedIntegrationManagement/>
                        </RoleBasedRoute>
                    }
                />
                <Route
                    path="/crm-source-integrations"
                    element={
                        <RoleBasedRoute allowedRoles={["super_admin", "uni_admin", "multi_user"]}>
                            <CRMSourceIntegrationManagement/>
                        </RoleBasedRoute>
                    }
                />


                <Route
                    path="/manage-analytics"
                    element={
                        <RoleBasedRoute allowedRoles={["super_admin", "uni_admin", "multi_user"]}>
                            <ReportsManagement/>
                        </RoleBasedRoute>
                    }
                />
                <Route
                    path="/users"
                    element={
                        <RoleBasedRoute allowedRoles={["super_admin", "uni_admin", "multi_user"]}>
                            {localStorage.getItem('role') === 'uni_admin' ? <UniAdminUsers /> : <UserManagement />}
                        </RoleBasedRoute>
                    }
                />
                <Route
                    path="/templates"
                    element={
                        <PrivateRoute>
                            <EmailTemplateManagement/>
                        </PrivateRoute>
                    }
                />

                <Route path="submissions/:eventId/:tourName/:tourId/:eventName"
                       element={
                           <PrivateRoute>
                               <SubmissionsPage/>
                           </PrivateRoute>
                       }/>
                <Route
                    path="/multi-dashboard"
                    element={
                        <RoleBasedRoute allowedRoles={["multi_user"]}>
                            <MultiUserDashboard/>
                        </RoleBasedRoute>
                    }
                />
                <Route
                    path="/multi-events"
                    element={
                        <RoleBasedRoute allowedRoles={["multi_user"]}>
                            <EventTemplateManagement/>
                        </RoleBasedRoute>
                    }
                />
                <Route
                    path="/multi-form-templates"
                    element={
                        <RoleBasedRoute allowedRoles={["multi_user"]}>
                            <FormTemplateManagement/>
                        </RoleBasedRoute>
                    }
                />
                <Route
                    path="/create-form-template"
                    element={
                        <RoleBasedRoute allowedRoles={["multi_user"]}>
                            <CreateFormTemplate/>
                        </RoleBasedRoute>
                    }
                />
                <Route
                    path="/multi-users"
                    element={
                        <RoleBasedRoute allowedRoles={["multi_user"]}>
                            <MultiUserUsers/>
                        </RoleBasedRoute>
                    }
                />
                <Route
                    path="/multi-templates"
                    element={
                        <RoleBasedRoute allowedRoles={["multi_user"]}>
                            <EmailTemplateTemplateManagement/>
                        </RoleBasedRoute>
                    }
                />
                {/* 404 Route */}
                <Route path="*" element={<NotFoundPage/>}/>
            </Routes>
        </Router>
    );
};

export default App;